export const isAddressValid = (source: string) => {
  // Check length
  if (source.length !== 48) {
    return false
  }
  // Check if address is valid base64
  // eslint-disable-next-line unicorn/better-regex, sonarjs/prefer-single-boolean-return
  if (!/[A-Za-z0-9+/_-]+/.test(source)) {
    return false
  }

  return true
}
